<template>
    <div>
        <section class="content">
            <div class="container-fluid">

                <div class="row clearfix">

                    <div class="bg-light-green" style="margin-top:-1% !important;">
                        <!-- <br> -->
                        <div class="row paddingku">
                            <div class="col-md-9 searching">
                                <span class="h_page">Keselarasan Kinerja Output dan Penganggaran</span> <br> <br>
                            </div>

                            <div class="col-md-3 searching">
                                <div class="input-group">
                                    <span class="input-group-btn">
                                        <button @click="Printing" type="button" class="btn bg-light-blue btn-sm waves-effect" title="Cetak Data">
                                            <i class="material-icons">print</i>
                                        </button>
                                    </span>
                                    <input class="form-control" type="text">
                                </div> <br>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 card">
                <!-- ============================================================ MULAI ======================================================================== -->
                        <br>
                        <!-- <h1>ini : {{unit_kerja_full}}</h1> -->
                        <div class="row">

                            <div class="col-md-6">
                                <span class="huruf_input">Unit Kerja</span>
                                <autocomplete
                                    :url="URL+ 'api/v1/simpeg_unit_kerja/autocomplete'"
                                    :customHeaders="{authorization: 'kikensbatara '+token }"
                                    anchor="unit_kerja"
                                    :initValue="''"
                                    :placeholder="unit_kerja_full"
                                    :classes="{ input: 'form-control'}"
                                    label="writer"
                                    :onShouldRenderChild="renderChild"
                                    :on-select="getAuto">
                                </autocomplete>
                            </div>

                            <div class="col-md-6">
                                
                            </div>

                        </div>

                        
                        <hr>
                        <div class="table-responsive" id="printMe">

                            <div>
                                <table style="width: 100%">
                                    <tr>
                                        <td style="width: 10%" class="text-right">
                                            <img src="images/logo konsel.png" alt="" width="50">
                                        </td>
                                        <td style="width: 80%" class="text-center h_kop_1">
                                            <b>
                                                {{unit_kerja_full}}<br>
                                                PERIODE {{renstraku.periode}}
                                            </b>
                                        </td >
                                        <td style="width: 10%"></td>
                                    </tr>
                                </table>

                                <hr>
                            </div>

                            <br><br>
                            <div class="text-center">
                                <span class="h_kop_1">
                                    <b>PROGRAM PER SASARAN</b>
                                </span>
                            </div> <br>

                            <table class="table-kiken" style="width: 100%">
                                <thead>
                                    <tr class="bgcol_kop_table kepala_table_f tabel_center h_cetak55">
                                        <th class="tabel_center text-center" width="2%" rowspan="2">NO</th>
                                        <th class="tabel_center text-center" width="8%" rowspan="2">SASARAN STRATEGIS</th>
                                        <th class="tabel_center text-center" width="5%" rowspan="2">SASARAN STRATEGIS BERORIENTSI HASIL</th>
                                        <th class="tabel_center text-center" width="8%" rowspan="2">INDIKATOR SASARAN STRATEGIS</th>
                                        <th class="tabel_center text-center" width="5%" rowspan="2">INDIKATOR SASARAN STRATEGIS BERKUALITAS</th>
                                        <th class="tabel_center text-center" width="3%" rowspan="2">IKU</th>
                                        <th class="tabel_center text-center" colspan="3">PROGRAM</th>

                                        <th class="tabel_center text-center" width="5%" rowspan="2">SASARAN PROGRAM TERKAIT DENGAN SASARAN STRATEGIS</th>

                                        <th class="tabel_center text-center" colspan="3">KEGIATAN</th>

                                        <th class="tabel_center text-center" width="5%" rowspan="2">SASARAN KEGIATAN TERKAIT DENGAN SASARAN PROGRAM</th>

                                        <th class="tabel_center text-center" colspan="2">KETERKAITAN ANGGARAN (Rp)</th>

                                        <th class="tabel_center text-center">CATATAN</th>
                                    </tr>
                                    <tr class="bgcol_kop_table kepala_table_f tabel_center h_cetak55">
                                        <th class="tabel_center text-center" width="8%">URAIAN PROGRAM</th>
                                        <th class="tabel_center text-center" width="8%">SASARAN PROGRAM</th>
                                        <th class="tabel_center text-center" width="8%">INDIKATOR SASARAN PROGRAM</th>

                                        <th class="tabel_center text-center" width="8%">URAIAN KEGIATAN</th>
                                        <th class="tabel_center text-center" width="8%">SASARAN KEGIATAN</th>
                                        <th class="tabel_center text-center" width="8%">INDIKATOR SASARAN KEGIATAN</th>

                                        
                                        <th class="tabel_center text-center" width="3%">YA</th>
                                        <th class="tabel_center text-center" width="3%">TIDAK</th>
                                        <th class="tabel_center text-center" width="5%">CATATAN</th>
                                    </tr>

                                </thead>

                                <tbody>
                                    <template >
                                        <tr class="tabel_top h_cetak66">
                                            <td class="text-center">1.</td>
                                            <td>Meningkatnya akses dan kualitas pendidikan</td>
                                            <td>-</td>
                                            <td>Angka Harapan lama sekolah</td>
                                            <td class="text-center">Ya</td>
                                            <td class="text-center">Ya</td>
                                            <td>Program Pendidikan Anak Usia Dini</td>
                                            <td>Meningkatnya akses dan kualitas pendidikan</td>
                                            <td>APK PAUD</td>
                                            <td class="text-center">Ya</td>
                                            <td>Pembangunan Gedung Sekolah</td>
                                            <td>Terbangunnya Gedung Sekolah</td>
                                            <td>Jumlah Unit Gedung Sekolah</td>
                                            <td class="text-center">Ya</td>
                                            <td>639560000</td>
                                            <td>-</td>
                                            <td>-</td>
                                        </tr>
                                    </template>

                                </tbody>
                            </table>






                        </div>

                        
          
                        <hr>
                <!-- ============================================================ MULAI ======================================================================== -->
                    </div>

                </div>

            </div>
      </section>



    </div>
</template>


<script>


    const ADD_URL = URL_APP+'api/v1/planning_renstra_renstra/';
    const ADD_URL_UNIT_KERJA = URL_APP+'api/v1/simpeg_unit_kerja/';
    const ADD_RENSTRA = URL_APP+'api/v1/planning_renstra_renstra/';
    const ADD_RENSTRA_PROGRAM = URL_APP+'api/v1/planning_renstra_program/';
    const URL_SERVER = URL_APP;
    import Autocomplete from 'vue2-autocomplete-js'


    export default {
        name: "planning_rpjmd",
        components: { Autocomplete },
        data() {
            return {
                renstraku : '',
                rpjmd_id : '',

                unit_kerja : '',
                unit_kerja_full : '',


                list_unit_kerja : [],
                list_renstra_program : [],
                page_first : 1,
                page_last : 0,
                cari_value : '',

                token : localStorage.token,
                URL : URL_SERVER
            };
        },

        mounted() {
            var get_profile = JSON.parse(localStorage.profile);
            this.unit_kerja_full = get_profile.profile.unit_kerja_nama;
            this.unit_kerja = get_profile.profile.unit_kerja;


            this.getData();

            localStorage.sidemenu = 'planing';
        },

        // =============================================================== METHODS =========================================================================
        methods : {
            getData: function(){
                this.getProgram();
                // this.getUnitKerja();
            },


        //TAMBAHAN
            getRenstra: function(){
                fetch(ADD_RENSTRA+'readData', {
                    method : 'POST',
                    headers : {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                    data_ke : this.page_first,
                    cari_value : this.cari_value,
                    unit_kerja : this.unit_kerja,
                    rpjmd_id : this.rpjmd_id
                    })
                }).then((res) => res.json()).then((res_data) => {
                    // console.log(res_data);
                    this.renstraku = res_data.data[0]
                })
            },
            getProgram: function(){
                fetch(ADD_RENSTRA_PROGRAM+'LaporanreadData', {
                    method : 'POST',
                    headers : {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                    data_ke : this.page_first,
                    cari_value : this.cari_value,
                    unit_kerja : this.unit_kerja,
                    rpjmd_id : this.rpjmd_id
                    })
                }).then((res) => res.json()).then((res_data) => {
                    // console.log(res_data);
                    this.list_renstra_program = res_data
                })
            },



        //TAMBAHAN

        // ================== AUTOCOMPLETE ====================
            renderChild(data) {
                return `
                <span><b>${data.unit_kerja}</b></span>
                <span style='font-size:80%'>${data.ref_instansi}</span>
                `
            },
            getAuto : function(obj){
                this.unit_kerja = obj.id;
                this.unit_kerja_full = obj.unit_kerja;
                this.getData();
                // console.log(obj);
                
            },
        // ================== AUTOCOMPLETE ====================


        
        // ================== PAGINASI ====================
            alertku : function(type, title){
                this.$swal({
                    type: type,
                    title: title,
                    showConfirmButton: false,
                    timer: 800
                });
            },

            btn_prev : function(){
                if(this.page_first>1){
                    this.page_first--
                }else{
                    this.page_first = 1;
                }
                this.getData();
            },

            btn_next : function(){
                if(this.page_first >= this.page_last){
                    this.page_first == this.page_last
                }else{
                    this.page_first++;
                }
                this.getData();
            },

            cari_data : function(){
                this.page_first = 1;
                this.getData();
            },
            btn_check_data_add : function(){
                if (this.rpjmd_id != '') {
                    this.check_data_add = true;
                }
            }, 
            Printing : function(){
                // printMe
                var elem = document.getElementById("printMe");
                var domClone = elem.cloneNode(true);

                var $printSection = document.getElementById("printSection");

                if (!$printSection) {
                    var $printSection = document.createElement("div");
                    $printSection.id = "printSection";
                    document.body.appendChild($printSection);
                }

                $printSection.innerHTML = "";
                $printSection.appendChild(domClone);
                window.print();

            },
            format_uang : function(angka, prefix){
                var rupiah = '';		
                var angkarev = angka.toString().split('').reverse().join('');
                for(var i = 0; i < angkarev.length; i++) if(i%3 == 0) rupiah += angkarev.substr(i,3)+'.';
                return ''+rupiah.split('',rupiah.length-1).reverse().join('');
            },

        // ================== PAGINASI ====================
        },
        // =============================================================== METHODS =========================================================================

    };
</script>
